import React from "react";
import PropTypes from "prop-types";

const TableBaseOptionsComponent = ({
    filename,
    setHeaderTitle,
    download = false,
    search = false,
}) => {
    return {
        responsive: "standard",
        filterType: "multiselect",
        filter: false,
        download: download,
        print: false,
        search: search,
        viewColumns: false,
        selectableRows: "none",
        downloadOptions: {
            filename: filename,
            separator: ",",
            filterOptions: { useDisplayedColumnsOnly: true },
        },
        onRowClick: (rowData) => {
            setHeaderTitle(`${rowData[1]} - ${rowData[2]}`);
        }
    };
};

// ✅ Define PropTypes for better type safety
TableBaseOptionsComponent.propTypes = {
    filename: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    download: PropTypes.bool,
    search: PropTypes.bool,
};

export default TableBaseOptionsComponent;
